import Parse from "parse";
import {
  addImageIfExists,
  getClassName,
  setACL,
  setLimit,
  filterKeys
} from "./ParseConfiguration";
import { Partnership } from "../Models/Partnership";
import { handleError } from "./ErrorHandler.ts";


const PARTNERSHIP_TABLE = getClassName("Partnership");


export async function getPartnerships() {
  try {
    const query = new Parse.Query(PARTNERSHIP_TABLE)
    query.ascending("sortingPosition").addDescending("createdAt")
    const count = await query.count()
    setLimit(query, count)
    const result = await query.find()

    return result.map((parseObject) =>
      Partnership.convertFromParseObject(parseObject)
    )
  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function getPartnershipById(objectId) {
  try {
    const query = new Parse.Query(PARTNERSHIP_TABLE)
    const parseObject = await query.get(objectId)
    const result = Partnership.convertFromParseObject(parseObject)
    return result

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function addOrUpdatePartnership(newPartnership, logoImage, heroImage) {
  try {
    const Partnership = PARTNERSHIP_TABLE
    const partnership = new Partnership()
    Object.entries(newPartnership)
      .filter((key) => !filterKeys.includes(key[0]))
      .forEach((key) => {
        partnership.set(key[0], key[1])
      })
    setACLForNewObject(newPartnership.objectId, partnership)
    await addImageIfExists(partnership, logoImage, "logoImage")
    await addImageIfExists(partnership, heroImage, "heroImage")
    await partnership.save()

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function deletePartnership(objectId) {
  try {
    const query = new Parse.Query(PARTNERSHIP_TABLE)
    query.get(objectId)
    const result = await query.find()
    if (result.length >= 1) {
      await result[0].destroy()
    }

  } catch (error) {
    handleError(error)
    throw error
  }
}

function setACLForNewObject(parseObject, objectId) {
  if (objectId.length === 0) {
    setACL(parseObject)
  }
}

export async function updatePartnershipSortingPosition(objectId, sortingPosition) {
  try {
    const query = new Parse.Query(PARTNERSHIP_TABLE)
    const obj = await query.get(objectId)
    obj.set("sortingPosition", sortingPosition)
    await obj.save()
  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function updatePartnershipHidingValue(objectId, isHiding) {
  try {
    const query = new Parse.Query(PARTNERSHIP_TABLE)
    query.get(objectId)
    const result = await query.find()
    if (result.length >= 1) {
      result[0].set("hidden", isHiding)
      result[0].save()
    }

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function notifyPartnership(id, title) {
  const params = {
    partnershipId: id,
    partnershipTitle: title
  }
  return await Parse.Cloud.run("partnershipNotification", params)
}
